import { cmsApi } from '../cmsApi';

export const withSyncEndpoints = cmsApi.injectEndpoints({
  endpoints: builder => ({
    startSync: builder.mutation<void, void>({
      query: () => ({
        url: '/data-sync/start',
        method: 'PATCH',
      }),
    }),
  }),
});

export const { useStartSyncMutation } = withSyncEndpoints;
